import React, { Fragment } from 'react'
import getLabels from '../../utils/getLabels'

import FormShadow from '../FormShadow'

interface NewBookingFormRowHeaderProps {
  showTravelClass: boolean
  showLuggage: boolean
}

export default (props: NewBookingFormRowHeaderProps) => {
  const { showTravelClass, showLuggage } = props

  return (
    <Fragment>
      <span>No.</span>
      <span>{getLabels('id')}</span>
      <span>{getLabels('pnr')}</span>
      <span>{getLabels('first_name')}</span>
      <span>{getLabels('last_name')}</span>
      <span>{getLabels('date_of_birth')}</span>
      <span>{getLabels('gender')}</span>

      {showLuggage && <span>{getLabels('luggage')}</span>}

      {showTravelClass && (
        <span data-element="class">{getLabels('seat_class')}</span>
      )}

      <span></span>
      <span></span>

      <FormShadow />
    </Fragment>
  )
}
